export const ipSearchBaseURL = "https://www.sandisk.com";
export const baseStageURL = "https://www.sandisk.com";
// export const baseStageURL = "";

export const corporateURL="https://shop.sandisk.com";
// export const analyticsBaseURL="launch-bc7943f031b6.min.js";
//export const analyticsBaseURL="launch-bc7943f031b6.min.js"  launch-c0cacf82e563-staging.min.js;
export const ApiURL ="https://api.sandisk.com"
 
export const analyticsProdURL = "https://assets.adobedtm.com/012e215e77ba/241525ea565f/launch-bc7943f031b6.min.js";
export const analyticsStageURL = "https://assets.adobedtm.com/012e215e77ba/241525ea565f/launch-c0cacf82e563-staging.min.js";
 
export const analyticsProdTrackingID = "sandisk-onestore-production,sandisk-global-production"
export const analyticsStageTrackingID = "sandisk-onestore-staging,sandisk-global-staging"
 
export const sdGlobalSearchBaseURL = baseStageURL+"/tools/api/globalsearchquery";
export const sdSupportSearchBaseURL = baseStageURL+"/tools/api/globalsearchgroups";
 
export const tokenDistributor = ApiURL +  "/AemAsset/api/wtbauth/token"
export const getDistributorList = ApiURL + "/AemAsset/api/WtbAdmin/GetListItems";
export const cardsDefaultUrl = corporateURL + "/company/distributors";

 
export const newSdSupportSearchBaseURL = baseStageURL+"/tools/api/globalsearchquery";
export const newSdGroupApiBaseURL = baseStageURL+"/tools/api/globalsearchgroups";
 
export const suggestionAPI= baseStageURL+"/tools/api/searchsuggester";
export const corporateInfoURL= baseStageURL+'/content/experience-fragments/sndsk/newsroom/latest-corporate-information/master';
export const getHeadersURL = baseStageURL+'/content/experience-fragments/sndsk/header/web-header/header';
export const getSubnavURL = baseStageURL+'/content/experience-fragments/sndsk/header/subnav/company';
export const getFooterURL= baseStageURL+'/content/experience-fragments/sndsk/footer/web-footer/footer';
